<template>
  <teleport to="body">
    <transition name="fade-loader">
      <div v-if="isVisible" class="loader-overlay">
        <div class="loader-content">
          <div class="glow-ring">
            <img :src="logo" alt="App Logo" class="loader-logo" />
          </div>
          <p class="loader-text">Loading...</p>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { ref, watch, onMounted, nextTick } from 'vue'
import { getLoaderLogoImage } from '@/assets/Branding/branding.js'

export default {
  name: 'Loader',
  props: {
    loading: { type: Boolean, required: true },
  },
  setup(props) {
    const isVisible = ref(props.loading)
    const logo = ref('')

    watch(() => props.loading, val => (isVisible.value = val))

    onMounted(() => {
      nextTick(async () => {
        const loaderLogo = await getLoaderLogoImage()
        if (loaderLogo) logo.value = loaderLogo
      })
    })

    return { isVisible, logo }
  },
}
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;

  top: 80px;
  bottom: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  pointer-events: none;
}

.fade-loader-enter-active,
.fade-loader-leave-active {
  transition: opacity 0.4s ease-in-out;
}

.fade-loader-enter-from,
.fade-loader-leave-to {
  opacity: 0;
}

.fade-loader-enter-to,
.fade-loader-leave-from {
  opacity: 1;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: zoomIn 0.4s ease-out both;
}

.glow-ring {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(100, 181, 246, 0.2) 30%, transparent 70%);
  border: 3px solid rgba(100, 181, 246, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 10px rgba(100, 181, 246, 0.3);
  animation: rotateRing 2s linear infinite;
}

.loader-logo {
  height: 28px;
  width: 28px;
  animation: pulse 2s ease-in-out infinite;
  filter: drop-shadow(0 0 3px rgba(0, 188, 255, 0.4));
}

.loader-text {
  margin-top: 10px;
  font-size: 0.9rem;
  color: #4a90e2;
  font-weight: 500;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale(0.85);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rotateRing {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.08);
    opacity: 0.85;
  }
}
</style>
